export default __webpack_public_path__ + "static/media/iconTeacher.9b5f83ed.png";